import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { PopoverActionMenuItem } from './popover-action-menu.interfaces';

@Component({
  selector: 'ocp-popover-action-menu',
  imports: [TranslatePipe],
  templateUrl: './popover-action-menu.component.html',
  styleUrl: './popover-action-menu.component.scss',
  host: {
    class: 'popover-action-menu',
  },
})
export class PopoverActionMenuComponent {
  readonly items = input<PopoverActionMenuItem[]>([]);
  readonly menuAriaLabelKey = input('');
  readonly actionSelected = output<string>();

  protected readonly visibleItems = computed(() => this.items().filter(item => !item.hidden));

  protected onMenuItemClick(item: PopoverActionMenuItem): void {
    if (item.disabled) {
      return;
    }

    this.actionSelected.emit(item.id);
  }
}
